import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared.module';
import { ProjektflowchartRouterModule } from './projektflowchart-routing.module';
import { WidgetsComponentsModule } from 'src/app/components/kit/widgets/widgets-components.module';
import { FormsModule } from '@angular/forms';
import { ProjektFlowchartComponent } from './main/projektflowchart.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { FeatherModule} from 'angular-feather';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { WorkflowModule } from '../../workflow/workflow.module';

const COMPONENTS = [ProjektFlowchartComponent];

@NgModule({
	imports: [
		FeatherModule,
		FormsModule,
		NzDividerModule,
		PerfectScrollbarModule,
		ProjektflowchartRouterModule,
		SharedModule,
		WidgetsComponentsModule,
		WorkflowModule,
	],
	exports: [
		ProjektFlowchartComponent,
	],
	declarations: [...COMPONENTS]
})
export class ProjektFlowchartModule {}
